export enum CivilStatus {
  Married = 'MARRIED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED',
  Separated = 'SEPARATED',
}
